import { app_placeholder } from '../../../env.placeholders';
import { HttpArcgis } from '../../http';
import { LocalStorage } from '../../localStorage';
import { defineDefinitionExpression } from '../map/defExpHelper';

// method to update input label of dropdownlist component
export const updateInputValueToEmpty = (pDom: Element | null) => {
  Object.getOwnPropertyDescriptor(
    window.HTMLInputElement.prototype,
    'value'
  )?.set?.call(pDom, '');
  pDom?.dispatchEvent(new Event('change', { bubbles: true }));
};

// method to get info bulle for module
export const getInfoBulleMessage = (pModule: string) => {  
  switch (pModule) {
    case 'do':
      return {
        red: 'Temps sec',
        orange: 'Petite pluie',
        blue: 'Grosse pluie',
        green: 'Pas de déversement',
        grey: 'Pas d’information',
        black: 'Pas de télégestion',
      };
    case 'ecp':
      return {
        red: 'BC très sensible aux ECP',
        orange: 'BC sensible aux ECP',
        green: 'BC peu sensible aux ECP',
        purple: 'Sensibilité du BC aux ECP indéterminée (V amont > V aval )',
        grey: 'Non calculé',
        black: 'Pas de télégestion',
      };
    case 'pr':
      return {
        red: 'Anormal',
        orange: 'Elevé',
        blue: 'Faible',
        green: 'Normal',
        grey: 'Non calculé',
        black: 'Pas de télégestion',
      };
    case 'h2s':
      return {
        red: 'Risque fort',
        orange: 'Risque moyen',
        blue: 'Absence de risque',
        green: 'Risque faible',
        grey: 'Pas d’information',
        black: 'Pas de télégestion',
      };
    case 'indus':
      return {
        red: 'Anormal',
        orange: 'Elevé',
        green: 'Normal',
        grey: 'Pas d’information',
      };
    case 'milieu':
      return {
        red: 'Très sensible',
        orange: 'Peu sensible',
        green: 'Sensible',
        grey: 'Non sensible',
        black: 'Pas de télégestion',
      };
    case 'pluie':
      return {
        red: 'Temps sec',
        blue: 'Temps de pluie',
        green: 'Pas de déversement',
        grey: 'Absence de données',
        black: 'Pas de télégestion',
      };
    case 'hydro':
      return {
        red: new Date().getFullYear().toString(),
        orange: (new Date().getFullYear()-1).toString(),
        blue: (new Date().getFullYear()-2).toString(),
      };
    default:
      return {};
  }
}

// create formBody for request
export const createFormBody = (
  pOption: string,
  pQuery: string,
  pUser: string,
  pModule?: string
) => {
  const formBody: string[] = [];
  formBody.push('where=' + pQuery);
  if (pOption === 'commune') {
    if(pModule === 'indus'){
      formBody.push('outFields=Name,InseeCode');
      formBody.push('orderByFields=Name');
    } else {
      formBody.push('outFields=Commune,InseeCode');
      formBody.push('orderByFields=Commune');
    }
    formBody.push('returnDistinctValues=true');
    formBody.push('returnGeometry=false');
  } else {
    formBody.push('outFields=Description,Code');
    formBody.push('returnGeometry=false');
    formBody.push('orderByFields=Description');
  }
  formBody.push('f=json');
  formBody.push('user=' + pUser);
  const formBodyToSend = formBody.join('&');
  return formBodyToSend;
};

// update options of commune dropdownlist
export const getOptionsCommunes = async (pSessionCode: string, pServiceId: string, pModule: string) => {
  let data: any[] = [];
  const query = defineDefinitionExpression(
    {},
    'modules',
    pSessionCode
  );
  const formBodyToSend = createFormBody(
    'commune',
    query,
    LocalStorage.userMail.get()!,
    pModule
  );

  try {
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/' + pServiceId + '/query',
      JSON.stringify(formBodyToSend)
    );
    let datas: any[] = [];
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datas = responseSections.data.features;
      // get attibutes
      datas.forEach((feat) => {
        data.push({
          name: (pModule === 'indus' && pServiceId === '7') ? feat['attributes'].Name : feat['attributes'].Commune,
          code: feat['attributes'].InseeCode,
        });
      });
    } else {
      console.log('Aucune données !');
    }
  } catch (error) {
    console.log('Failed to get data for dropdownlist !', error);
  }
  return data;
};

// update options of installation dropdownlist
export const getOptionsInstalls = async (
  pQuery: string,
  pServiceId: string
) => {
  let data: any[] = [];
  const query = pQuery;
  const formBodyToSend = createFormBody(
    'installation',
    query,
    LocalStorage.userMail.get()!
  );

  try {
    const responseSections = await HttpArcgis.post(
      app_placeholder.VITE_APP_ARCGIS_SERVER + '?path=/'+pServiceId+'/query',
      JSON.stringify(formBodyToSend)
    );
    let datas: any[] = [];
    if (
      responseSections.status === 200 &&
      responseSections.data.features !== undefined
    ) {
      datas = responseSections.data.features;
      // get attibutes
      datas.forEach((feat) => {
        data.push({
          name: feat['attributes'].Description,
          code: feat['attributes'].Code,
        });
      });
    } else {
      console.log('Aucune données !');
    }
  } catch (error) {
    console.log('Failed to get data for dropdownlist !', error);
  }
  return data;
};

// reset dropdownlist, its label and its const options
export const resetOptions = (pValue: any, domId: string, setter: any) => {
  resetImputLabel(domId);
  setter([pValue]);
};

export const resetImputLabel = (pIdDom: string) => {
  const dom = document.querySelector('#' + pIdDom);
  dom && updateInputValueToEmpty(dom);
};
